<template>
  <div class="nav-bar-comp">
    <ul class="nav-list nav-list--fixed">
      <li
        v-for="(item, index) in fixedItemList"
        :key="item.id"
        class="nav-item"
        :class="{
          'is-selected': item.id === selectedItemId
        }"
        @click="onItemClick(item, index)"
      >
        <span>{{ item.cate_name }}</span>
        <img
          class="down-img"
          src="../assets/images/down.png"
          v-if="item.hasChildren"
        />
      </li>
    </ul>
    <ul class="nav-list nav-list--normal" id="navListNormal">
      <li
        :id="'navItem_'+ item.id"
        v-for="(item, index) in itemList"
        :key="item.id"
        class="nav-item"
        :class="{
          'is-hard': item.isHardItem,
          'is-selected': item.id === selectedItemId
        }"
        @click="onItemClick(item, index + fixedItemList.length)"
      >
        <span>{{ item.cate_name }}</span>
        <img
          class="down-img"
          src="../assets/images/down.png"
          v-if="item.hasChildren"
        />
      </li>
    </ul>
    <router-link :to="'/tagManage?type='+type" v-if="!noManage">
      <img class="menu-img" src="../assets/images/menu.png" alt="menu" />
    </router-link>
  </div>
</template>
<script>
export default {
  name: 'navBar',
  props: {
    noManage: {
      type: Boolean,
      default: false
    },
    fixedItemList: {
      type: Array,
      default: function() {
        return [];
      }
    },
    itemList: {
      type: Array,
      default: function() {
        return [];
      }
    },
    selectedItemId: {
      type: Number
    },
    onItemClick: {
      type: Function
    },
    type: {
      type: Number,
      default: 0
    }
  }
};
</script>

<style lang="stylus" scoped>
.nav-bar-comp {
	height: 88px;
  padding-left: 30px
  padding-right: 55px
  position: sticky
  left: 0
  right: 0
  top: 88px
  display: flex
  align-items: center
  overflow: hidden;
  background-color: #fff;
  z-index: 99;
  .nav-list{
    white-space nowrap
     overflow-x scroll
     overflow-y: hidden;
     	-webkit-overflow-scrolling: touch;

    position relative
      .nav-item {
        position relative;
        display inline-block
        margin-right 50px
        padding-top 4px
        padding-bottom 10px
        // border-bottom 6px solid transparent
        color #666
        font-size 30px

        .down-img{
          width 25px
          margin-left 16px
        }
        &.is-selected{
          font-weight: bold;
          // border-bottom-color: #8FC31E;
          &::after{
            content: '';
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0px;
            height: 6px;
            background-color: #8FC31E;
            
          }
        }
        &.is-hard{
          margin-right 57px
        }
      }
    &.nav-list--fixed{
      display: flex;
      align-items center;
      overflow-y: hidden;
    }
    &.nav-list--normal{
      flex: 1;
    }
  }

  .menu-img{
    position absolute
    width: 78px
    top 7px
    right 18px
    bottom 5px
  }
}
</style>
